function wowo($) {
  setTimeout(function () {
    jQuery("html").addClass("show-c");
    var wTop = jQuery(window).scrollTop(),
      wHeight = jQuery(window).height(),
      wBottom = wTop + wHeight;
    jQuery(".wowo:not(.animated)").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.height(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");

        setTimeout(function () {
          //me.removeClass("animated wowo");
        }, 1500);
      }
    });

    jQuery(".fullwidth-intro-bar:not(.active) .item").each(function () {
      var me = jQuery(this),
        meTop = me.offset().top,
        meHeight = me.innerHeight(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;

      if (meTop > limitTop && meBottom < limitBottom) {
        jQuery(this).parents(".fullwidth-intro-bar").addClass("active");
        // Find the span element containing the number
        var numElement = jQuery(this).find("span");
        var num = numElement.html();
        num = num.replace(/,/g, ""); // Remove commas from the number
        num = parseFloat(num); // Convert to float (if needed)

        // Ensure animateNumber plugin is properly loaded
        if (jQuery.fn.animateNumber) {
          var comma_separator_number_step = jQuery.animateNumber.numberStepFactories.separator(",");
          numElement.animateNumber(
            {
              number: num,
              numberStep: comma_separator_number_step,
            },
            {
              easing: "swing",
              duration: 2000,
            }
          );
        } else {
          console.error("animateNumber plugin is not available.");
        }
      }
    });
  }, 100);
}

function cookie() {
  if (jQuery(".pop-up").length > 0) {
    if (jQuery.cookie("open-pop-up")) {
      jQuery(".pop-up").removeClass("active");
    } else {
      jQuery(".pop-up").addClass("active");
    }
    jQuery.cookie("open-pop-up", "email-open", {
      expires: 1,
      path: "/",
    });

    $(".pop-up .icon-close").click(function () {
      jQuery(".pop-up").removeClass("active");
    });
    $(".header__top-bar p").click(function (e) {
      e.stopPropagation();
      jQuery(".pop-up").addClass("active");
    });
  }
}

function video() {
  jQuery(".video-link.mp4,.is-video").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });

    var video_url = jQuery(this).find(".data-video").html();
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video  muted loop="loop" controls="controls"><source src="' + video_url + '" type="video/mp4"></video>');
    jQuery(".video-light-box").fadeIn(300);

    // var videoElements = jQuery(".video-light-box video");
    // var hls = new Hls();
    // videoElements.each(function () {
    //   var videoSrc = jQuery(this).find("source").attr("src");
    //   var videoElement = this;
    //   if (videoSrc.endsWith(".mp4")) {
    //   } else {
    //     hls.loadSource(videoSrc);
    //     hls.attachMedia(videoElement);
    //   }
    // });
  });
  jQuery(".video-link.file").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    var video_url = jQuery(this).find(".data-video").html();
    var caption = jQuery(this).find(".data-video").attr("data-caption");
    jQuery(".video-light-box")
      .find(".play-iframe-video")
      .append('<video controls="controls"><source src="' + video_url + '" type="video/mp4"> <track src="' + caption + '"  srclang="en" label="English" kind="subtitles" default /></video>');
    jQuery(".video-light-box").fadeIn(300);
  });
  jQuery(".video-link.embed").click(function (event) {
    event.preventDefault();
    jQuery(document).bind("mousewheel DOMMouseScroll", function (event) {
      event.preventDefault();
    });
    jQuery(document).bind("touchmove", function (event) {
      event.preventDefault();
    });
    jQuery(".video-light-box").fadeIn(300);
    var html = jQuery(this).find(".data-video").html();
    console.log(html);
    jQuery(".video-light-box").find(".play-iframe-video").html(html);
  });

  jQuery(".video-light-box .icon-close").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });

  jQuery(".video-light-box").click(function () {
    jQuery(document).unbind("mousewheel DOMMouseScroll");
    jQuery(document).unbind("touchmove");
    jQuery(".video-light-box").fadeOut(300);
    setTimeout(function () {
      jQuery(".video-light-box").find(".play-iframe-video").html("");
    }, 300);
  });
  jQuery(".video-light-box .play-iframe-video").click(function (event) {
    event.stopPropagation();
  });

  jQuery(".video-link,.is-video").click(function (event) {
    event.stopPropagation();
    var vvv = jQuery(this).children(".video").find("video");
    vvv.on("loadedmetadata", function () {
      vvv.trigger("play");
    });
    // vvv.trigger('play');

    setTimeout(function () {
      var ss = jQuery(".video-light-box .video-box video");
      ss.trigger("play");
    }, 300);
  });

  jQuery(".video-show").click(function (event) {
    event.stopPropagation();
    jQuery(this).children(".text-and-img").addClass("is-active");
    var vvv = jQuery(this).parents(".video").find("video");

    if (jQuery(this).hasClass("is-active")) {
      vvv.trigger("play");
      jQuery(this).removeClass("is-active");
    } else {
      jQuery(this).addClass("is-active");
      vvv.trigger("pause");
    }
  });
}

function hlsVideo() {
  // var videoElements = document.querySelectorAll("video");

  var videoElements = document.querySelectorAll("video");

  videoElements.forEach(function (videoElement) {
    var videoSrc = videoElement.getAttribute("src");

    if (videoSrc && videoSrc.endsWith(".mp4")) {
    } else {
      var hls = new Hls();
      hls.loadSource(videoSrc);
      hls.attachMedia(videoElement);
    }
  });
}

function resizeWindow() {
  if ($(window).width() > 991) {
    var height = $(".select-item").eq(2).innerHeight() - $(".select-item").eq(1).innerHeight();
    $(".select-item").eq(3).css("margin-top", -height);
  } else {
    $(".select-item").eq(3).css("margin-top", "0");
  }
}

function slider() {
  $(".product-lists--slider-items .slider-items:not('.slick-initialized')").each(function () {
    var _self = $(this);
    _self.slick({
      dots: false,
      arrows: false,
      infinite: false,
      // speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      // autoplay: true,
      adaptiveHeight: false,
      fade: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: true,
      draggable: true,

      swipeToSlide: true,   
  touchMove: true,  
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
  $(".related-product--slider:not('.slick-initialized')").each(function () {
    var _self = $(this);
    _self.slick({
      dots: false,
      arrows: false,
      infinite: false,
      // speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      // autoplay: true,
      adaptiveHeight: false,
      fade: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: true,
        draggable: true,

        swipeToSlide: true,   
        touchMove: true,  
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
  $(".text-and-video .slider-items:not('.slick-initialized')").each(function () {
    var _self = $(this);
    _self.slick({
      dots: false,
      arrows: false,
      infinite: false,
      // speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      // autoplay: true,
      adaptiveHeight: false,
      fade: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: true,
      draggable: true,

      swipeToSlide: true,   
      touchMove: true,  
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
  $(".mobile-image-slider:not('.slick-initialized')").each(function () {
    var _self = $(this);
    _self.slick({
      dots: true,
      arrows: false,
      infinite: true,
      // speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      // autoplay: true,
      adaptiveHeight: false,
      fade: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      focusOnSelect: true,
      draggable: true,
    });
  });
}

function click() {
  //  Product Lists

  $(".product-lists--slider-items .slider-items").eq(0).addClass("active");
  $(".product-lists--nav li").eq(0).addClass("active");
  $(".product-lists--nav li").click(function () {
    $(this).addClass("active").siblings().removeClass("active");
    $(".product-lists--slider-items .slider-items").eq($(this).index()).addClass("active").siblings().removeClass("active");
  });
  // Faqs

  $(".faq-sec .faq-item h3").click(function () {
    $(this).siblings().stop().slideToggle(300).parent().toggleClass("active");
    $(this).parent().siblings().removeClass("active").find(".drop-box").slideUp(300);
  });

  // Product Color Filters

  $(".color-tab .tab-item").click(function () {
    $(this).toggleClass("active").siblings().removeClass("active");
    var val = $(this).find("a").text().toLowerCase();
    if (val != "all shades") {
      $(".radios--main").hide();
      $(".radios--main[data-" + val + '="true"]').show();
    } else {
      $(".radios--main").show();
    }
  });

  selfBlur(jQuery);
  function selfBlur($) {
    $("body").on("click", function (e) {
      var _pop = $(".pop-up .content");

      if (!_pop.is(e.target) && _pop.has(e.target).length === 0) {
        jQuery(".pop-up").removeClass("active");
      }
      var _select1 = $(".select .select-input");
      var _select2 = $(".reason .select-input");
      if (!_select1.is(e.target) && _select1.has(e.target).length === 0) {
        $(".select .select-input").removeClass("active").find("ul").slideUp(300);
      }
      if (!_select2.is(e.target) && _select2.has(e.target).length === 0) {
        $(".reason .select-input").removeClass("active").find("ul").slideUp(300);
      }
    });
  }
}
function giveMore(button, targetUl, showNumber, speed) {
  let list = showNumber;
  const row = jQuery(targetUl);
  row.find(".list").hide();
  row.find(".list:lt(" + list + ")").show();

  $(button).on("click", function () {
    const items = row.find(".list");
    if ($(this).hasClass("active")) {
      items.slice(list).slideUp(speed ? speed : 400);
      $(this).removeClass("active");
    } else {
      items.slice(list).slideDown(speed ? speed : 400);
      $(this).addClass("active");
    }
  });
}



function scrollFix() {
  if($('[data-block-type="buy-buttons"] .product-buy-buttons--cta').length) {
    var $buyButtonsForm = $('[data-block-type="buy-buttons"] .product-buy-buttons--form');
    var $buyButtonsCta = $('[data-block-type="buy-buttons"] .product-buy-buttons--cta');
    var offsetTop = $buyButtonsForm.offset().top;
    var height = $buyButtonsForm.height();
  
    $(window).on("scroll", function () {
      var scrollTop = $(window).scrollTop();
      if (scrollTop > offsetTop + height) {
        $buyButtonsCta.addClass("fixed");
        $('html').addClass("button-fix");
      } else {
        $buyButtonsCta.removeClass("fixed");
        $('html').removeClass("button-fix");
      }
    });
  }

}
var $ = jQuery.noConflict();
jQuery(document).ready(function () {
  wowo();
  slider();
  click();
  video();
  scrollFix();
  $(".twentytwenty-container[data-orientation!='vertical']").twentytwenty({ default_offset_pct: 0.5 });

  // $(".selected-shade").each(function () {
  //   var $this = $(this).find(".selected-shade--title");
  //   var $target = $(this).find(".shade-lists");
  //   giveMore($this, $target, 1, 300);
  // });
  resizeWindow();
  jQuery(window).on("load", function () {});
  jQuery(window).scroll(function () {
    wowo();
    scrollFix();
  });

  jQuery(window).resize(function () {
    resizeWindow();
  });
});
